import React from 'react';
import BaseTile from '../../../components/Tile/BaseTile';
import ContentSection from '../../../components/layout/ContentSection';
import { useEventCountsPerObjectType } from './hooks/useEventCountsPerObjectType';

const StatNumber = ({ value }) => (
  <span className="font-semibold text-gray-900">
    {typeof value === 'number' ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value) : '—'}
  </span>
);

/**
 * Tile listing the total number of events per object type.
 * Shows top N (default 5) object types by event count, sorted desc; shows all if small.
 */
const EventCountsPerObjectTypeTile = ({ activeFile, topN = 5 }) => {
  const { data, loading, error } = useEventCountsPerObjectType(activeFile);

  const entries = React.useMemo(() => {
    if (!data) return [];
    const arr = Object.entries(data);
    arr.sort((a, b) => (b[1] - a[1]) || a[0].localeCompare(b[0]));
    if (arr.length <= topN + 2) return arr; // show all if small
    return arr.slice(0, topN);
  }, [data, topN]);

  return (
    <ContentSection spacing="lg">
      <BaseTile
        title="Events per Object Type"
        loading={loading}
        error={error}
        minHeight="md"
      >
        <div className="p-4">
          {entries.length === 0 && !loading && !error ? (
            <div className="text-sm text-gray-500">No data available.</div>
          ) : (
            <ul className="divide-y divide-gray-200">
              {entries.map(([type, count]) => (
                <li key={type} className="py-2 flex items-center justify-between">
                  <span className="text-sm text-gray-700 truncate pr-4" title={type}>{type}</span>
                  <StatNumber value={count} />
                </li>) )}
            </ul>
          )}
          {data && Object.keys(data).length > entries.length && (
            <div className="mt-3 text-xs text-gray-500">Showing top {entries.length} of {Object.keys(data).length} types</div>
          )}
        </div>
      </BaseTile>
    </ContentSection>
  );
};

export default EventCountsPerObjectTypeTile;
